import { FC } from 'react';
import { NumberUtils, Tr, TypeUtils } from '@utils';
import { ChargerProperties, Product, ProductCategoryType } from '@services';
import { Box, Grid } from '@mui/material';
import { VoltaageModalDialog, IVoltaageModalDialogProps, StripedTableCell } from '@components/common';

export interface IChargingPointViewDialogProps extends IVoltaageModalDialogProps {
	entity?: Product;
}

export const ChargingPointViewDialog: FC<IChargingPointViewDialogProps> = ({ entity, ...props }) => {
	if (entity?.category !== ProductCategoryType.CHARGING_POINT) {
		return null;
	}

	const chargerProps = TypeUtils.convert(ChargerProperties, entity.properties);

	return (
		<VoltaageModalDialog
			title={<Tr.Portal path="product.charging-point-view-dialog.title" options={{ name: entity.name }} />}
			dividers
			{...props}
		>
			<Box sx={{ paddingX: 10, paddinTop: 3, paddingBottom: 5 }}>
				<Grid container>
					<StripedTableCell title={<Tr.Portal path="product.brand" />}>{chargerProps?.brand || '-'}</StripedTableCell>
					<StripedTableCell title={<Tr.Portal path="product.current-type" />}>
						{chargerProps?.currentType || '-'}
					</StripedTableCell>

					<StripedTableCell greyBg title={<Tr.Portal path="product.charger-using-type" />}>
						{chargerProps?.chargerUsingType || '-'}
					</StripedTableCell>
					<StripedTableCell greyBg title={<Tr.Portal path="product.charger-phase-type" />}>
						{chargerProps?.chargerPhaseType || '-'}
					</StripedTableCell>

					<StripedTableCell title={<Tr.Portal path="product.number-of-connectors" />}>
						{NumberUtils.formatAsNumber(chargerProps.numberOfConnectors, { decimalScale: 0 })}
					</StripedTableCell>
					<StripedTableCell title={<Tr.Portal path="product.maximum-power" />}>
						{NumberUtils.formatAsNumber(chargerProps.maximumPower, { decimalScale: 1, suffix: 'kW' })}
					</StripedTableCell>

					<StripedTableCell greyBg title={<Tr.Portal path="product.rated-voltage" />}>
						{NumberUtils.formatAsNumber(chargerProps.ratedVoltage, { decimalScale: 1, suffix: 'V' })}
					</StripedTableCell>
					<StripedTableCell greyBg title={<Tr.Portal path="product.max-current" />}>
						{NumberUtils.formatAsNumber(chargerProps.maxCurrent, { decimalScale: 1, suffix: 'A' })}
					</StripedTableCell>

					<StripedTableCell title={<Tr.Portal path="product.home-usage" />}>
						<Tr.Portal path={chargerProps?.homeUsage ? 'yes' : 'no'} />
					</StripedTableCell>
					<StripedTableCell title={<Tr.Portal path="product.office-usage" />}>
						<Tr.Portal path={chargerProps?.officeUsage ? 'yes' : 'no'} />
					</StripedTableCell>
				</Grid>
			</Box>
		</VoltaageModalDialog>
	);
};
